import { render } from "./Abtests.vue?vue&type=template&id=cd265a66&bindings={\"id\":\"props\",\"group\":\"props\",\"allFilters\":\"options\",\"fetchData\":\"options\",\"refresh\":\"options\"}"
import script from "./Abtests.vue?vue&type=script&lang=js"
export * from "./Abtests.vue?vue&type=script&lang=js"
script.render = render

export default script